import React, {
  PropTypes,
  Component
} from 'react';
import './style.less';
import mobx from 'mobx';
import Icon from '../Icon';
import DateRangeBar from '../PopWindow/DateRangeBar';
import DateUtil from './DateUtil';
import tools from '../../utils/tools';
import moment from 'moment';

export default class DateRange extends Component {

  title = ''

  handleDateClick = (date) => {
    if (this.props.onChange) {
      let value;
      switch (date.DateType) {
        case 0:
          value = DateUtil.getDateTime('0');
          this.title = '';
          break;
        case 1:
          value = DateUtil.getDateTime('1');
          this.title = '本日';
          break;
        case 2:
          value = DateUtil.getDateTime('4');
          this.title = '本周';
          break;
        case 3:
          value = DateUtil.getDateTime('7');
          this.title = '本月';
          break;
        case 4:
          value = DateUtil.getDateTime('9');
          this.title = '本季';
          break;
        case 5:
          value = DateUtil.getDateTime('10');
          this.title = '本年';
          break;
        default:
          value = {
            begin: date.StartTime,
            end: date.EndTime
          };
          this.title = '';
          break;
      }
      value.begin = value.begin ? moment(value.begin, 'YYYY-M-D').format('YYYY-MM-DD') : '';
      value.end = value.end ? moment(value.end, 'YYYY-M-D').format('YYYY-MM-DD') : '';
      this.props.onChange([{ text: value.begin, value: value.begin }, { text: value.end, value: value.end }]);
    }
  }
  // reportName 报表唯一识别，为了解决日期始终停留在 本周
  render() {
    const {
      value, id
    } = this.props;
    const startDate = DateUtil.formatValue(value[0]).toString();
    const endDate = DateUtil.formatValue(value[1]).toString();
    return (
      <div className='dateRange'>
        <DateRangeBar
          dateClick={this.handleDateClick}
          calendarBtnCls="f-left"
          dateRangeTitle={this.title ? this.title : (tools.isNull(startDate) && tools.isNull(endDate) ? '' : (startDate + ' - ' + endDate))}
          startDate={startDate}
          endDate={endDate}
          isAllInput={false}
          // reportName={id}
          hasAll={true}
          ifUseDefaultData={false}
        />
      </div>
    )
  }

}
